export default __webpack_public_path__ + "static/media/dashport_ico.22f2d11c.ico";